import React, { PropsWithChildren, ReactNode } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Link } from '@vk-hr-tek/ui/Link';
import { Divider } from '@vk-hr-tek/ui/Divider';
import { Typography } from '@vk-hr-tek/ui/Typography';

interface ContentSurveysProps {
  label: ReactNode;
  bgWhite: boolean;
  onCreate: VoidFunction;
}

export const ContentSurveys = ({
  label,
  bgWhite,
  children,
  onCreate,
}: PropsWithChildren<ContentSurveysProps>) => {
  return (
    <Box
      px="24"
      radius="l"
      bgcolor={bgWhite ? 'bg.light.primary' : 'bg.greyscale.primary'}
    >
      <Box
        py="16"
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box gap="8" display="flex" alignItems="center">
          <Icon name="rectangle_2_horizontal_outline" size="16" />

          <Typography variant="subtitle2">{label}</Typography>
        </Box>

        <Link
          size="small"
          stroke={false}
          onClick={onCreate}
          endIcon={<Icon name="add" size="16" />}
        >
          <Typography color="accent.text.blue" variant="subtitle2">
            Создать опрос
          </Typography>
        </Link>
      </Box>

      {children && <Divider />}

      {children && (
        <Box py="16" display="flex" flexDirection="column" gap="12">
          {children}
        </Box>
      )}
    </Box>
  );
};
